import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import {
  superAdminLoginStart,
  clearVerificationState
} from '../../../store/redux-slices/login'
import { verifyStaffVerificationCodeStart, verifyStaffVerificationCodeSuccess } from '../../../store/redux-slices/staffSlice'
import { getLoginToken, removeLoginToken, getItem } from '../../../utils/storageUtils'
import { AdminsRoutes } from '../../../routes'
import { toast } from '../../../components/Toast'

const useSuperAdminSignin = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    loading,
    verificationCode,
    requiresVerification,
    userId: adminUserId
  } = useSelector((state) => state.login)

  const { loading: verificationLoading } = useSelector((state) => state.staff)
  const [showPassword, setShowPassword] = useState(false)
  const [showVerification, setShowVerification] = useState(false)

  useEffect(() => {
    const token = getLoginToken()

    // Only allow access if properly logged in (no pending verification)
    if (token && !requiresVerification) {
      navigate(AdminsRoutes.Dashboard)
    } else if (!token || requiresVerification) {
      removeLoginToken()
    }
  }, [navigate, requiresVerification])
console.log("useSuperAdminSignin", {loading, verificationCode, requiresVerification, adminUserId , showVerification});
  // Watch for verification code requirement
  useEffect(() => {
    if (verificationCode && requiresVerification) {
      setShowVerification(true)
    }
  }, [verificationCode, requiresVerification])

  // Original Super Admin login handler (no verification needed)
  const handleSignIn = ({ user, password }) => {
    dispatch(superAdminLoginStart({ user, password, navigate }))
  }

  // Staff login - handles verification automatically
  const handleInitialLogin = ({ user, password }) => {
    dispatch(superAdminLoginStart({
      user,
      password,
      navigate,  // Empty function - let the saga handle the flow
      isStaffLogin: true
    }))
  }

  // Staff login - verification step using existing staff saga
  const handleVerificationSubmit = ({ verificationCode }) => {
    if (!adminUserId) {
      toast('Session expired. Please login again.', 'error')
      resetVerification()
      return
    }

    dispatch(verifyStaffVerificationCodeStart({
      data: {
        adminUserId,
        verificationCode
      },
      completeLogin: true, // Flag to indicate this should complete login
      onSuccess: () => {
        toast('Login successful!', 'success')
        setShowVerification(false)
        dispatch(clearVerificationState())
        navigate(AdminsRoutes.Dashboard)
      },
      onError: (message) => {
        toast(message, 'error')
      }
    }))
  }

  // Reset verification state
  const resetVerification = () => {
    setShowVerification(false)
    dispatch(clearVerificationState())
  }

  return {
    // Original Super Admin login
    loading,
    showPassword,
    setShowPassword,
    navigate,
    handleSignIn,

    // Staff login specific
    showVerification,
    verificationLoading,
    requiresVerification,
    handleInitialLogin,
    handleVerificationSubmit,
    resetVerification
  }
}

export default useSuperAdminSignin
